export default "__VITE_ASSET__x0kD6fgk__"